<script>
import TabPanel from "@/components/content/tabset/TabPanel";

export default {
  name: "ContentTabset",
  components: {
    TabPanel
  },
  data() {
    return {
      activeIndex: 1
    };
  },
  methods: {
    tab(index) {
      this.activeIndex = index;
    },
    isActive(index) {
      return index === this.activeIndex;
    }
  }
};
</script>

<style lang="stylus" scoped>
@import "ContentTabset"
</style>
